import React from 'react';
interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}


export default function ConfirmModal({
  open,
  title = "Confirm action",
  message,
  onConfirm,
  onCancel,
}: ConfirmModalProps): JSX.Element | null {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="dm-confirm-modal bg-white rounded-xl p-6 w-[90%] max-w-sm shadow-xl">
        <h2 className="text-lg font-semibold mb-2">{title}</h2>
        <p className="text-sm text-black mb-6">{message}</p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="dm-confirm-no px-4 py-2 rounded-lg border text-black hover:bg-toggle"
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="dm-confirm-yes px-4 py-2 rounded-lg bg-main text-white"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
